import axios from "axios";
export const basePath = 'https://gameapi.partydaysport.com';
// export const basePath = 'http://192.168.31.210:48080';
const http = {
    path(_path) {
        return basePath + _path;
    },
    get(path, data) {
        return axios.get(this.path(path), {
            params: data
        })
    },
    post(path, data) {
        return axios.post(this.path(path), data)
    }
}

export default http;